import { mapGetters } from 'vuex'

export const trainer_start_mix = {
  props: ['trainer'],  
  data() {
    return {
      params: {},
      status: 'init',
      result: null
    }
  },
  computed: {
    ...mapGetters({
      user: 'user'
    })
  },
  methods: {
    start(params) {
      this.params = params
      this.status = 'start'
    },
    showResult(data) {      
      this.result = data
      this.result.gameParams = this.params
      this.result.user_id = this.user.id
      this.result.trainer = this.trainer.id
      this.status = 'result'   
    } 
  },
  mounted() {   
    if (this.$route.params.isHomework) {
      this.start(this.$route.params.params)
    }
  }
};